import Divider    from "_components/atoms/divider";
import Typography from "_components/atoms/typography";
import GameCard   from "_components/molecules/gameCard";

import useStyles from "./styles";

const getFormatedCardData = obj => {
	return {
		name              : obj.name,
		liveStreamsCount  : obj.currentStreamCount,
		totalStreamsCount : obj.totalStreams,
		image             : obj.image
	};
};

const component = ( { gameList = [] } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div>
			<div className = { classes.titleContainer }>
				<Typography
					className = { ` ${ classes.title }` }
					title     = { "Recommended Games For You" }
				/>

				<Divider />
			</div>

			<div className = { classes.gameListcontainer }>

				{gameList.map ( ( item, key ) => (
					<GameCard
						key                 = { key }
						data                = { item }
						getFormatedCardData = { getFormatedCardData }
					/>
				)
				) }

			</div>
		</div>
	);
};

export default component;